import { useSearchOrchestration } from "../hooks/useSearchOrchestration";
import SearchHeader from "./SearchHeader";
import SearchResults from "./SearchResults";
import React from "react";
export default function Search({ onClose }) {
    const { query, setQuery, trackTypingOnce, loading, error, groups, noResultSuggestions, isTypoFallback, recent, handleClearRecent, handleSelectSuggestion, handleSelectRecentItem, } = useSearchOrchestration();
    function handleQueryChange(value) {
        trackTypingOnce(value);
        setQuery(value);
    }
    return (<>
      <SearchHeader onBack={onClose} onQueryChange={handleQueryChange}/>

      <div className="flex-1 overflow-y-auto p-4">
        <SearchResults query={query} loading={loading} error={error} groups={groups} noResultSuggestions={noResultSuggestions} isTypoFallback={isTypoFallback} recent={recent} onClearRecent={handleClearRecent} onSelectRecentItem={handleSelectRecentItem} onSelectSuggestion={handleSelectSuggestion}/>
      </div>
    </>);
}
